/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChatExportItemDto
 */
export interface ChatExportItemDto {
    /**
     * 
     * @type {string}
     * @memberof ChatExportItemDto
     */
    id: string;
    /**
     * 
     * @type {object}
     * @memberof ChatExportItemDto
     */
    conversationId?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ChatExportItemDto
     */
    fileName: string;
    /**
     * 
     * @type {object}
     * @memberof ChatExportItemDto
     */
    exportedAt?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChatExportItemDto
     */
    isSharedWithProvider: boolean;
    /**
     * Temporary signed download URL for the exported PDF (expires in 1 hour)
     * @type {object}
     * @memberof ChatExportItemDto
     */
    fileUrl?: object | null;
    /**
     * File size of the exported PDF
     * @type {object}
     * @memberof ChatExportItemDto
     */
    fileSize?: object | null;
}

/**
 * Check if a given object implements the ChatExportItemDto interface.
 */
export function instanceOfChatExportItemDto(value: object): value is ChatExportItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('isSharedWithProvider' in value) || value['isSharedWithProvider'] === undefined) return false;
    return true;
}

export function ChatExportItemDtoFromJSON(json: any): ChatExportItemDto {
    return ChatExportItemDtoFromJSONTyped(json, false);
}

export function ChatExportItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatExportItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'fileName': json['fileName'],
        'exportedAt': json['exportedAt'] == null ? undefined : json['exportedAt'],
        'isSharedWithProvider': json['isSharedWithProvider'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
    };
}

export function ChatExportItemDtoToJSON(json: any): ChatExportItemDto {
    return ChatExportItemDtoToJSONTyped(json, false);
}

export function ChatExportItemDtoToJSONTyped(value?: ChatExportItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversationId': value['conversationId'],
        'fileName': value['fileName'],
        'exportedAt': value['exportedAt'],
        'isSharedWithProvider': value['isSharedWithProvider'],
        'fileUrl': value['fileUrl'],
        'fileSize': value['fileSize'],
    };
}

